import axiosClient from '@/config/api/axios'
import { INTEGRATION_CONNECTIONS } from '@/config/api/endpoints'
import { connectionListSchema } from '@/schemas/integrations/connection'

/**
 * Connections owned by the signed-in user.
 *
 * Deliberately throws rather than returning `[]` on failure: an empty list
 * renders as "you have connected nothing", which would be a lie during an
 * outage and would invite the user to reconnect apps they already have.
 *
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function fetchConnections(options = {}) {
  const { data } = await axiosClient.get(INTEGRATION_CONNECTIONS, { signal: options.signal })
  return connectionListSchema.parse(data).items
}
